import { render, staticRenderFns } from "./ProtectionPolicy.vue?vue&type=template&id=785b2ae2&"
import script from "./ProtectionPolicy.vue?vue&type=script&lang=js&"
export * from "./ProtectionPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports